import * as FleetActions from './Fleet/fleet.actions';
import * as AuthActions from './Auth/auth.actions';
import * as AppActions from './App/app.actions';

export const actionCreators = Object.assign(
  {},
  FleetActions,
  AuthActions,
  AppActions,
);

export default actionCreators;



// WEBPACK FOOTER //
// ./src/actionCreators.js